import { render, staticRenderFns } from "./CasesHome.vue?vue&type=template&id=4fe45427&scoped=true&"
import script from "./CasesHome.vue?vue&type=script&lang=js&"
export * from "./CasesHome.vue?vue&type=script&lang=js&"
import style0 from "./CasesHome.vue?vue&type=style&index=0&id=4fe45427&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe45427",
  null
  
)

export default component.exports